import { Component, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsFacade, customEncode } from '@piqet-angular/data';
import { ADMIN_EOL_CONSUMER, PRODUCT_MANUFACTURE_IMPACT } from '@piqet-angular/shared';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { MenuService } from 'libs/features/src/lib/menu/menu.service';

@Component({
  selector: 'piqet-angular-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent {
  @Input() activatedPath: any;
  @Input() reportype: any;
  @Input() projectNameIso: any;
  childActivatedPath: any;
  activeRoute: any;
  menuItems: any;
  @Input() projectName: any;
  @Input() projectId: any;
  isProjectDetail: boolean = false;
  scenarioName: any;
  isInProjects: any;
  currentRoute: any;
  isCustomWidth = false;
  encodedUrl: string = 'true';

  constructor(
    public menu: MenuService,
    public route: ActivatedRoute,
    public router: Router,
    public projectFacade: ProjectsFacade,
    private sharedService: SharedService
  ) {
    this.menuItems = menu.getMenu();
    this.encodedUrl = customEncode(btoa(this.encodedUrl));
    this.currentRoute = this.route.snapshot.routeConfig?.path;
    this.isInProjects =
      location.href.includes('projects-setting') ||
      location.href.includes('project-detail-report') ||
      location.href.includes('product-configuration');
    this.sharedService.scenarioNameObs$.subscribe((res: any) => {
      this.scenarioName = res || localStorage.getItem('scenarioName');
      localStorage.setItem('scenarioName', this.scenarioName);
      if (location.href.includes('/my-organization/project-report-setting')) {
        this.childActivatedPath = this.scenarioName;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.projectNameIso = changes?.['projectNameIso']?.currentValue;
    if (this.activatedPath == 'Packaging projects') {
      this.childActivatedPath = changes?.['projectName']?.currentValue;
    } else if (this.activatedPath == 'Product projects') {
      this.childActivatedPath = changes?.['projectName']?.currentValue;
    }
  }

  ngOnInit() {
    switch (this.activatedPath) {
      case 'organization-data-mapping':
        this.activatedPath = 'Organization mapping';
        break;
      case 'projects':
        this.activatedPath = 'Packaging projects';
        break;
      case 'customMaterials':
      case 'adminCustomMaterials':
        this.activatedPath = 'Custom materials';
        break;
      case 'customConversion':
      case 'adminCustomConversion':
        this.activatedPath = 'Custom conversion';
        break;
      case 'customReuse':
      case 'adminCustomReuse':
        this.activatedPath = 'Custom reuse';
        break;
      case 'customStorage':
      case 'adminCustomStorage':
        this.activatedPath = 'Custom storage';
        break;
      case 'customTrucks':
      case 'adminCustomTrucks':
        this.activatedPath = 'Custom trucks';
        break;
      case 'customFilling':
      case 'adminCustomFilling':
        this.activatedPath = 'Custom filling';
        break;
      case 'wasteScenarios':
      case 'adminWasteScenarios':
        this.activatedPath = 'Waste scenario';
        break;
      case 'customTransport':
      case 'adminCustomTransport':
        this.activatedPath = 'Custom transport chain';
        break;
      case 'manageUsers':
        this.activatedPath = 'Users';
        break;
      case 'manageTeams':
      case 'AdminForManageTeams':
        this.activatedPath = 'Teams';
        break;
      case 'manageProjectWorkflow':
        this.activatedPath = 'Project workflow';
        break;
      case 'manageScenarioWorkflow':
        this.activatedPath = 'Scenario workflow';
        break;
      case 'manageProductGroups':
        this.activatedPath = 'Product group';
        break;
      case 'organizationPreferences':
        this.activatedPath = 'Organization preferences';
        break;
      case 'import-custom-template':
        this.activatedPath = 'Import';
        break;
      case 'organization-main-mapping':
        this.activatedPath = 'Organization mapping';
        break;
      case 'import-project':
        this.activatedPath = 'Import';
        break;
      case 'projectSavingLogs':
        this.activatedPath = 'Project saving logs';
        break;
      case 'manageSupport':
        this.activatedPath = 'Manage support';
        break;
      case 'exportLogs':
        this.activatedPath = 'Export logs';
        break;
      case 'SSOSettings':
        this.activatedPath = 'Login settings';
        break;
      case 'manageUsers/details/:id':
      case 'AdminManageUsers/details/:id':
        this.activatedPath = 'Users';
        this.childActivatedPath = 'User details';
        break;
      case 'AdminForManageTeams/details/:id':
        this.activatedPath = 'Team';
        this.childActivatedPath = ' Team details';
        break;
      case 'admin-materials':
        this.activatedPath = 'Material';
        break;
      case 'admin-ingredients':
        this.activatedPath = 'Ingredient';
        break;
      case 'admin-recycled':
        this.activatedPath = 'Recycled material impact';
        break;
      case 'userLoginLogs':
        this.activatedPath = 'Login logs';
        break;
      case 'verification':
        this.activatedPath = 'T&C verification';
        break;
      case 'signup-requests':
        this.activatedPath = 'Signup requests';
        break;
      case 'adminOrganization':
        this.activatedPath = 'Organizations';
        break;
      case 'area-based-conversion':
        this.activatedPath = ' Area based conversion';
        break;
      case 'Transport':
        this.activatedPath = 'Transport mode';
        break;
      case 'processing-storage':
        this.activatedPath = 'Storage';
        break;
      case 'processing-custom-conversion':
        this.activatedPath = ' Custom conversion';
        break;
      case 'processing-data-conversion':
        this.activatedPath = 'Conversion';
        break;
      case 'energy-and-ancillary':
        this.activatedPath = ' Energy and ancillary';
        break;
      case 'processing-waste':
        this.activatedPath = 'Waste';
        break;
      case 'refrigareted-truck':
        this.activatedPath = 'Refrigerated truck';
        break;
      case 'processing-custom-truck':
        this.activatedPath = 'Custom truck';
        break;
      case 'admin-eol-rc':
        this.activatedPath = 'EOL-RC';
        break;
      case 'admin-eol-lf':
        this.activatedPath = 'EOL-LF';
        break;
      case 'admin-eol-cc':
        this.activatedPath = 'EOL-CC';
        break;
      case 'admin-eol-hc':
        this.activatedPath = 'EOL-HC';
        break;
      case 'admin-eol-er':
        this.activatedPath = 'EOL-ER';
        break;
      case 'admin-eol-ic':
        this.activatedPath = 'EOL-IC';
        break;
      case 'admin-eol-od':
        this.activatedPath = 'EOL-OD';
        break;
      case 'admin-eol-sw':
        this.activatedPath = 'EOL-SW';
        break;
      case 'admin-eol-se':
        this.activatedPath = 'EOL-SE';
        break;
      case 'admin-eol-lt':
        this.activatedPath = 'EOL-LT';
        break;
      case 'admin-eol-ad':
        this.activatedPath = 'EOL-AD';
        break;
      case 'admin-eol-rates':
        this.activatedPath = 'EOL retail rates';
        break;
      case ADMIN_EOL_CONSUMER:
        this.activatedPath = 'EOL consumer rates';
        break;
      case 'material-types':
        this.activatedPath = ' Material types';
        break;
      case 'Recyclability':
        this.activatedPath = 'Recyclability';
        break;
      case 'Combustibility':
        this.activatedPath = 'Combustibility';
        break;
      case 'Compostability':
        this.activatedPath = 'Compostability';
        break;
      case 'CircularEconomyParameter':
        this.activatedPath = 'Circular economy parameters';
        break;
      case 'pallet-type':
        this.activatedPath = 'Pallet type';
        break;
      case 'Project-Status':
        this.activatedPath = 'Project status';
        break;
      case 'scenario-status':
        this.activatedPath = 'Scenario status';
        break;
      case 'converting-processes':
        this.activatedPath = 'Converting process';
        break;
      case 'misc-simulation':
        this.activatedPath = 'Misc simulation';
        break;
      case 'admin-conversion-mapping':
        this.activatedPath = 'Conversion mapping';
        break;
      case 'admin-recycled-content':
        this.activatedPath = 'Recycled content';
        break;
      case 'admin-product-package':
        this.activatedPath = 'Product package ratio';
        break;
      case 'state':
        this.activatedPath = 'State';
        break;
      case 'country':
        this.activatedPath = 'Country';
        break;
      case 'CountryIndetifiers':
        this.activatedPath = 'Country identifiers';
        break;
      case 'city':
        this.activatedPath = 'City';
        break;
      case 'AdminManageUsers':
        this.activatedPath = 'Users';
        break;
      case 'manageTeams/details/:id':
        this.activatedPath = 'Team';
        this.childActivatedPath = 'Team details';
        break;
      case 'adminOrganization/details/:id':
        this.activatedPath = 'Organization';
        this.childActivatedPath = 'Organization details';
        break;
      case 'export-logs':
        this.activatedPath = 'Export logs';
        break;
      case 'admin-news':
        this.activatedPath = 'News';
        break;
      case 'Transactions':
        this.activatedPath = ' Transactions';
        break;
      case 'admin-news/details/:id':
        this.activatedPath = 'News';
        this.childActivatedPath = 'News details';
        break;
      case 'admin-roles':
      case 'roles':
        this.activatedPath = 'Roles';
        break;
      case 'import':
        this.activatedPath = 'Import';
        break;
      case 'import/validation-report/:id':
      case 'import/import-report/:id':
        this.activatedPath = 'Import';
        break;
      case 'log-entries':
        this.activatedPath = 'Log entries';
        break;
      case 'admin-roles/roleDetails/:roleId':
      case 'roles/roleDetails/:roleId':
        this.activatedPath = 'Roles';
        this.childActivatedPath = 'Role details';
        break;
      case 'OrganizationEquivalancyUnits':
        this.activatedPath = 'Organization equivalency units';
        break;
      case 'projects-setting/:id':
      case 'project-detail-report':
        this.activatedPath = 'Packaging projects';
        this.isProjectDetail = true;
        this.childActivatedPath = this.projectName;
        this.isCustomWidth = true;
        break;
      case 'product-configuration/:id':
        this.activatedPath = 'Product projects';
        this.isProjectDetail = true;
        this.childActivatedPath = this.scenarioName;
        this.isCustomWidth = true;
        break;
      case 'org-report-setting':
        this.activatedPath = 'Project report setting';
        this.childActivatedPath = 'Project report setting details';
        break;
      case 'project-report-setting/org-report-setting':
        this.activatedPath = 'Project report setting';
        break;
      case 'upload-sku':
        this.activatedPath = 'Internal data template';
        break;
      case 'project-report-setting':
        this.activatedPath = 'Project report setting';
        break;
      case 'product-use-impact':
        this.activatedPath = 'Product use impact';
        break;
      case PRODUCT_MANUFACTURE_IMPACT:
        this.activatedPath = 'Product manufacture impact';
        break;
      case 'report':
        this.activatedPath = 'Run organization report';
        this.isCustomWidth = true;
        break;
      case 'report-list':
        this.activatedPath = 'Report bug list';
        break;
      case 'tool-verification':
        this.activatedPath = 'Tool verification';
        break;
      case 'report-comparision/:id':
        this.activatedPath = 'Report comparison';
        break;
      case 'automation/list':
        this.activatedPath = 'Automation';
        break;
      case 'automation/edit':
        this.activatedPath = 'Automation';
        break;
      case 'automation/analytics':
        this.activatedPath = 'Automation analytics';
        break;
      case 'templates/list':
        this.activatedPath = 'Templates';
        break;
      case 'templates/placeholders':
        this.activatedPath = 'Templates';
        this.childActivatedPath = 'Placeholders';
        break;
      case 'ship-distance':
        this.activatedPath = 'Distance';
        break;
      // Report Builder routes
      case 'blocks':
        this.activatedPath = 'Template Blocks';
        break;
      case 'templates':
        this.activatedPath = 'Report Templates';
        break;
      case 'placeholders':
        this.activatedPath = 'Placeholder Registry';
        break;
      case 'conditions':
        this.activatedPath = 'Condition Registry';
        break;
      case 'block-editor/new':
        this.activatedPath = 'Template Blocks';
        this.childActivatedPath = 'Create Block';
        break;
      case 'block-editor/:id':
        this.activatedPath = 'Template Blocks';
        this.childActivatedPath = 'Edit Block';
        break;
      case 'builder/new':
        this.activatedPath = 'Report Templates';
        this.childActivatedPath = 'Create Template';
        break;
      case 'builder/:id':
        this.activatedPath = 'Report Templates';
        this.childActivatedPath = 'Edit Template';
        break;
      case 'report-preview/:templateId':
        this.activatedPath = 'Report Templates';
        this.childActivatedPath = 'Report Preview';
        break;
      default:
        this.activatedPath = 'Projects';
        this.isProjectDetail = false;
        break;
      case 'activity/:id':
        this.activatedPath = 'Sessions';
        break;
      case 'session/activity/:id':
        this.activatedPath = 'Session analytics';
        break;
    }
  }

  routeToPage() {
    this.activeRoute = this.route.snapshot.routeConfig?.path;
    switch (this.activeRoute) {
      case 'AdminManageUsers/details/:id':
        this.router.navigate(['/my-organization/AdminManageUsers']);
        break;
      case 'manageUsers/details/:id':
        this.router.navigate(['/my-organization/manageUsers']);
        break;
      case 'AdminForManageTeams/details/:id':
        this.router.navigate(['/my-organization/AdminForManageTeams']);
        break;
      case 'manageTeams/details/:id':
        this.router.navigate(['/my-organization/manageTeams']);
        break;
      case 'admin-news/details/:id':
        this.router.navigate(['/administrator/advanced/admin-news']);
        break;
      case 'adminOrganization/details/:id':
        this.router.navigate(['/administrator/user-management/adminOrganization']);
        break;
      case 'admin-roles/roleDetails/:roleId':
        this.router.navigate(['/administrator/advanced/admin-roles']);
        break;
      case 'roles/roleDetails/:roleId':
        this.router.navigate(['/my-organization/roles']);
        break;
      case 'projects-setting/:id':
        this.router.navigate(['/projects']);
        break;
      case 'product-configuration/:id':
        this.router.navigate(['/projects'], { queryParams: { isFromProj: this.encodedUrl } });
        break;
      case 'org-report-setting':
        this.router.navigate(['/my-organization/project-report-setting']);
        break;
      case 'project-report-setting/org-report-setting':
        this.router.navigate(['/my-organization/project-report-setting']);
        break;
      case 'templates/placeholders':
        this.router.navigate(['/administrator/emailConfiguration/templates/list']);
        break;
      case 'automation/edit':
        this.router.navigate(['/administrator/emailConfiguration/automation/list']);
        break;
      // Report Builder child routes → navigate back to list, preserving
      // admin vs. user context (the report-builder module is mounted under
      // both /report-builder and /administrator/report-builder).
      case 'block-editor/new':
      case 'block-editor/:id': {
        const base = this.router.url.startsWith('/administrator/')
          ? '/administrator/report-builder' : '/report-builder';
        this.router.navigate([`${base}/blocks`]);
        break;
      }
      case 'builder/new':
      case 'builder/:id':
      case 'report-preview/:templateId': {
        const base = this.router.url.startsWith('/administrator/')
          ? '/administrator/report-builder' : '/report-builder';
        this.router.navigate([`${base}/templates`]);
        break;
      }
      case 'project-detail-report':
        const encodedValue = encodeURIComponent(this.projectId);
        this.router.navigate([
          `projects/projects-setting/${customEncode(btoa(encodedValue))}/report-generation`,
        ]);
        break;
      case 'session/activity/:id':
        this.router.navigate(['/administrator/analytics/session']);
        break;
      case 'import/validation-report/:id':
      case 'import/import-report/:id':
        this.router.navigate(['/administrator/advanced/import']);
        break;
    }
  }

  routeOfScenario() {
    this.activeRoute = this.route.snapshot.routeConfig?.path;
    switch (this.activeRoute) {
      case 'project-detail-report':
        const encodedValue = encodeURIComponent(this.projectId);
        this.router.navigate([
          `projects/projects-setting/${customEncode(btoa(encodedValue))}/report-generation`,
        ]);
        break;
      default:
        return;
        break;
    }
  }

  truncateText(text: string, limit: number): string {
    const words = text.split(' ');
    if (words.length > limit && text.length > 65) {
      return words.slice(0, limit).join(' ') + '...';
    } else {
      return text;
    }
  }

  routeToSettings() {
    const projId: any = localStorage.getItem('pCode')?.toString() || this.projectId;
    if (this.activatedPath.toLowerCase() == 'packaging projects') {
      this.router.navigate([`projects/projects-setting/${customEncode(btoa(projId))}/setting`]);
      setTimeout(() => {
        this.sharedService.accessSideBarData(() => {});
      }, 0);
    } else if (this.activatedPath.toLowerCase() == 'product projects') {
      const producConfigId: any = localStorage.getItem('productConfigId');
      this.router.navigate([
        `projects/product-configuration/${customEncode(btoa(producConfigId))}/setting`,
      ]);
      setTimeout(() => {
        this.sharedService.accessProductSideBarData(() => {});
      }, 0);
    }
  }

  ngOnDestroy() {
    this.projectFacade.clearProjectName();
  }
}
